import React from 'react';
import { withPrefix } from 'gatsby';

var Icon = function Icon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      id = _ref.id,
      color = _ref.color;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    style: {
      fill: color
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: withPrefix("sprite.svg#" + id)
  }));
};

export default Icon;